module.exports = __webpack_public_path__ + "static/media/deer_stone_text_02.35525536.jpg";